import React, { useState } from "react";

interface ApproveModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSend: (price: number) => void;
}

const ApproveModal: React.FC<ApproveModalProps> = ({ isOpen, onClose, onSend }) => {
    const [price, setPrice] = useState<number | "">("");

    if (!isOpen) return null;

    const handleSend = () => {
        if (price && price > 0) {
            onSend(Number(price));
            onClose();
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4 z-50">
            <div className="bg-white text-black rounded-lg shadow-lg w-full max-w-md p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
                >
                    &times;
                </button>

                {/* Header */}
                <h2 className="text-lg font-semibold mb-4 text-center font-urbanist">
                    Approve Request
                </h2>

                {/* Price Input */}
                <div className="mb-6">
                    <label
                        htmlFor="price"
                        className="block text-sm font-medium text-gray-700 mb-2"
                    >
                        Enter Price to accept as booking amount
                    </label>
                    <input
                        type="number"
                        id="price"
                        value={price}
                        onChange={(e) =>
                            setPrice(e.target.value ? Number(e.target.value) : "")
                        }
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-base focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        placeholder="Enter price"
                    />
                </div>

                {/* Buttons */}
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSend}
                        className={`px-4 py-2 rounded-lg text-white bg-gradient-to-r from-[#FFC951] to-[#C94DAA] hover:opacity-90`}
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApproveModal;
